import React, { useRef, useEffect } from 'react';
import { isEmpty } from 'lodash';
import CompareCareersDropdown from './careers/CompareCareersDropdown';
import CompareDegreesDropdown from './degrees/CompareDegreesDropdown';
import xIcon from '../../../ASUPhotos/icons/me3_white_Xicon.svg';
import Favorite from '../Favorite';

function TopModal(props) {
  const {
    blackBox,
    careerToCompare,
    degreeToCompare,
    closeModal,
    degree,
    img,
    originalCareer,
    showCompareCareersSearchBar,
    showCompareDegreesSearchBar,
    tenant,
    showDegreeComparisonDropdown,
    focusX,
  } = {
    ...props,
  };

  const xIconRef = useRef(null);

  useEffect(() => {
    if (focusX) {
      xIconRef.current.focus();
    }
  }, [focusX]);

  const renderCompareDropdown = () => {
    if (!degree && isEmpty(careerToCompare)) {
      return (
        <CompareCareersDropdown
          tenant={tenant}
          showCompareCareersSearchBar={showCompareCareersSearchBar}
        />
      );
    }

    if (degree && isEmpty(degreeToCompare) && showDegreeComparisonDropdown) {
      return (
        <CompareDegreesDropdown
          tenant={tenant}
          showCompareDegreesSearchBar={showCompareDegreesSearchBar}
        />
      );
    }

    return null;
  };

  const ariaLabelItem = originalCareer
    ? originalCareer.titleEn
    : degree.titleEn;

  const handleCloseWithParam = () => {
    props.closeModal(
      props.modalItem,
      props.userProfileId,
      props.userProfileTenantId
    );
  };

  return (
    <div className="top-modal">
      <div
        className="top-modal-career-image"
        style={{ backgroundImage: `url(${img})` }}
        data-cy="career-image"
      >
        <div className="row" id="back-button" data-cy="back-button">
          <div className="back-container" data-cy="back-container">
            <button
              type="button"
              ref={xIconRef}
              style={{ backgroundImage: `url(${xIcon})` }}
              onMouseDown={() => handleCloseWithParam()}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key))
                  closeModal(
                    props.modalItem,
                    props.userProfileId,
                    props.userProfileTenantId
                  );
              }}
              tabIndex="0"
              className="x-cross-back-button focus-indicator"
              data-cy="x-cross-back-button"
              alt="close"
              aria-label={`close modal for ${ariaLabelItem}`}
              id="close-modal-x-icon"
            />
            {originalCareer ? (
              <div className="modal-favorite-container">
                <Favorite
                  careerId={originalCareer.id}
                  careerName={originalCareer.titleEn}
                  career={originalCareer}
                  location={props.location}
                />
              </div>
            ) : null}
          </div>
        </div>
        <div className="career-tile">{blackBox}</div>
        {renderCompareDropdown()}
      </div>
    </div>
  );
}

export default TopModal;
